
import React, { useState, useEffect, useRef } from 'react';

function BannerSection() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const phrases = [
    'UN AROMA HACE UN RECUERDO',
    'QUE DESPIERTA EMOCIONES',
    'LA FRAGANCIA PERFECTA',
    'DEFINE TU ESENCIA',
    'Y TE HACE INOLVIDABLE'
  ];

  return (
    <section 
      className="banner-section" 
      ref={sectionRef}
      style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/products/prodgeneral.jpeg') center/cover no-repeat`
      }}
    >
      <div className="banner-content">
        <div className="banner-phrases">
          {phrases.map((phrase, index) => (
            <div
              key={index}
              className={`banner-phrase ${isVisible ? 'visible' : ''} ${
                index % 2 === 0 ? 'from-right' : 'from-left'
              }`}
              style={{ animationDelay: `${index * 0.3}s` }}
            >
              <div className="phrase-box">
                <span>{phrase}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="banner-text">
          <p>
            Descubre nuestra nueva colección de fragancias inspiradas en las mejores casas de perfumería. Cada aroma cuenta una historia única y te transporta a lugares mágicos. Encuentra tu esencia perfecta.
          </p>
        </div>
      </div>
    </section>
  );
}

export default BannerSection;
